// @flow
import logo from 'assets/img/logo.svg';

export default () => ({
    Logo: {
        display: 'inline-block',
        background: 'url(' + logo + ') no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        width: ({ width = 130 }: *) => width,
        height: ({ width = 130 }: *) => width / 6.5
    }
});

